/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        /****************
        **  Primary nav dropdown delay
        *****************/
        var hoverDelay = 225;
        var exitDelay = 275;
        $('.nav-primary > ul > li').each(function () {
          var $li = $(this);
          var timer;
          $li.on('mouseenter', function () {
            timer = setTimeout(function () {
              $li.addClass('is-hover');
            }, hoverDelay);
          });
          $li.on('mouseleave', function () {
            timer = setTimeout(function () {
              $li.removeClass('is-hover');
            }, exitDelay);
          });
        });


        /****************
        **  Jump menu
        *****************/
        $('.jump-select').on('change', function () {
          var target = $(this).val();
          if (target) {
            window.location.href = target;
          }
        });


        /****************
        **  Carousels
        *****************/
        $('.testimonials-carousel').each(function() {
          $(this).slick({
            rows: 0,
            dots: false,
            arrows: false,
            infinite: true,
            speed: 400,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 8000,
          });
        });

        /****************
        **  Sticky menu
        *****************/
        var $win    = $(window);
        var $sticky = $('.primary-sticky-nav');
        var $header = $('header.banner');
        var headerBottom = 0;
        var ticking = false;

        if (!$sticky.length || !$header.length) return;

        function setSticky(active) {
          $sticky.toggleClass('is-active', active);
          $sticky.attr('aria-hidden', active ? 'false' : 'true');
        }

        function measure() {
          // Recompute where header ends (accounts for font loading / admin bar changes / responsive shifts)
          headerBottom = $header.offset().top + $header.outerHeight();
        }

        function update() {
          var y = $win.scrollTop();
          setSticky(y >= headerBottom);
          ticking = false;
        }

        function requestUpdate() {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
          }
        }

        // init
        measure();
        update();

        $win.on('scroll', requestUpdate);
        $win.on('resize', function() {
          measure();
          update();
        });


       $('.fa-form-wrapper').each(function () {
         var wrapper = this;
         var utmParams = new URLSearchParams(window.location.search);

         var utmFieldMap = {
           utm_source:   'tfa_287',
           utm_medium:   'tfa_291',
           utm_campaign: 'tfa_293',
           utm_content:  'tfa_289',
           utm_term:     'tfa_295'
         };

         var observer = new MutationObserver(function () {
           var programAbbr = $(wrapper).data('program-abbr');
           var programTitle = $(wrapper).data('program-title');
           var $field248 = $(wrapper).find('input[name="tfa_248"]');
           var $field286 = $(wrapper).find('input[name="tfa_286"]');

           if ($field248.length) {
             $field248.val(programAbbr).trigger('change');
           }
           if ($field286.length) {
             $field286.val(programTitle).trigger('change');
           }

           var utmFieldsFound = false;
           Object.keys(utmFieldMap).forEach(function (param) {
             var value = utmParams.get(param);
             if (!value) return;

             var $field = $(wrapper).find('input[name="' + utmFieldMap[param] + '"]');
             if ($field.length) {
               $field.val(value).trigger('change');
               utmFieldsFound = true;
             }
           });

           if ($field248.length || $field286.length || utmFieldsFound) {
             observer.disconnect();
           }
         });

         observer.observe(wrapper, {
           childList: true,
           subtree: true
         });
       });

       /****************
       **  Faculty hide/show
       *****************/
       $('.faculty-list-toggle').on('click', function(e) {
         e.preventDefault();
         var $button = $(this).find('button');
         var $row = $(this).closest('.faculty-row');
         var $items = $row.find('.faculty-hidden, .faculty-shown');

         if ($button.data('open')) {
           $items.slideUp(150, function() {
             $(this).removeClass('faculty-shown').addClass('faculty-hidden');
           });
           $button.text('See All');
           $button.data('open', false);
         } else {
           $items.slideDown(250, function() {
             $(this).removeClass('faculty-hidden').addClass('faculty-shown');
           });
           $button.text('Close');
           $button.data('open', true);
         }
       });

      },

      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        function setProgramFinderLift() {
          var $hero = $('.homepage-hero');
          var $box  = $hero.find('.program-finder form.bg-white').first();
          if (!$hero.length || !$box.length) return;

          var lift = Math.round($box.outerHeight() / 2);
          $hero[0].style.setProperty('--pf-lift', lift + 'px');
        }

        $(function(){
          setProgramFinderLift();
          $(window).on('load resize', setProgramFinderLift);
        });



        $('.program-finder-form').on('submit', function(e) {
          e.preventDefault();

          var level = $('#filter-1').val();
          var topic = $('#filter-2').val();

          var params = new URLSearchParams();

          if (level) {
            params.set('program-level', level);
          }

          if (topic) {
            params.set('topic', topic);
          }

          var url = $(this).attr('action');

          if (params.toString()) {
            url += '?' + params.toString();
          }

          window.location.href = url;
        });



      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single_program': {
      init: function() {


      }
    },
    'programs': {
      init: function() {


        var filters = {
          'program-level': '',
          'topic': ''
        };

        var $buttons = $('.filter-btn');
        var $selects = $('.filter-select');
        var $listings = $('.program-listing');
        var $emptyMessage = $('.program-listings__empty');

        function applyFilters() {
          var visibleCount = 0;

          $listings.each(function () {
            var $item = $(this);
            var levels = ($item.data('program-level') || '').toString().split(' ').filter(Boolean);
            var topics = ($item.data('topic') || '').toString().split(' ').filter(Boolean);

            var matchesLevel = !filters['program-level'] || levels.indexOf(filters['program-level']) !== -1;
            var matchesTopic = !filters['topic'] || topics.indexOf(filters['topic']) !== -1;

            var show = matchesLevel && matchesTopic;

            $item.toggleClass('is-hidden', !show);

            if (show) {
              visibleCount++;
            }
          });

          if ($emptyMessage.length) {
            $emptyMessage.prop('hidden', visibleCount > 0);
          }
        }

        function syncUrl() {
          var params = new URLSearchParams(window.location.search);

          if (filters['program-level']) {
            params.set('program-level', filters['program-level']);
          } else {
            params.delete('program-level');
          }

          if (filters['topic']) {
            params.set('topic', filters['topic']);
          } else {
            params.delete('topic');
          }

          var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          window.history.replaceState({}, '', newUrl);
        }

        function applyFiltersFromUrl() {
          var params = new URLSearchParams(window.location.search);

          ['program-level', 'topic'].forEach(function (group) {
            var value = params.get(group);

            if (!value) {
              value = '';
            }

            filters[group] = value;

            var $matchingButton = $('.filter-btn[data-filter-group="' + group + '"][data-filter-value="' + value + '"]');

            $('.filter-btn[data-filter-group="' + group + '"]').removeClass('is-active');

            if ($matchingButton.length) {
              $matchingButton.addClass('is-active');
            }

            $('.filter-select[data-filter-group="' + group + '"]').val(value);
          });

          applyFilters();
        }

        $buttons.on('click', function () {
          var $button = $(this);
          var group = $button.data('filter-group');
          var value = $button.data('filter-value');

          filters[group] = value;

          $('.filter-btn[data-filter-group="' + group + '"]').removeClass('is-active');
          $button.addClass('is-active');

          $('.filter-select[data-filter-group="' + group + '"]').val(value);

          syncUrl();
          applyFilters();
        });

        $selects.on('change', function () {
          var $select = $(this);
          var group = $select.data('filter-group');
          var value = $select.val();

          filters[group] = value;

          $('.filter-btn[data-filter-group="' + group + '"]').removeClass('is-active');
          $('.filter-btn[data-filter-group="' + group + '"][data-filter-value="' + value + '"]').addClass('is-active');

          syncUrl();
          applyFilters();
        });

        applyFiltersFromUrl();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
